<div class="wetter_content_container">

  <mat-card class="unwetter-card mat-elevation-z2" [style]="isLandKreis ? 'display: inline-flex;':''">
    <mat-card-header [class]="'warn-header ' + getClassByStufe(unwetterVorhersage.zusammenfassung.hoechsteStufe)">
      <mat-card-title class="warn-header-title">
        {{unwetterVorhersage.zusammenfassung.hoechsteStufe > 0
        ? unwetterVorhersage.ort.ort.replace("_", " ")
        : 'Keine aktuellen Unwetterwarnungen für ' + unwetterVorhersage.ort.ort.replace("_", " ")}}
      </mat-card-title>
      <mat-card-subtitle>
        <div>
          <span class="summary-text">
            Höchste Stufe: <strong>{{unwetterVorhersage.zusammenfassung.hoechsteStufe}}</strong>
          </span>
          <span class="summary-text">
            Höchste Stufe Vorabinfo: <strong>{{unwetterVorhersage.zusammenfassung.hoechsteStufeVorabinformation}}</strong>
          </span>
        </div>
      </mat-card-subtitle>
    </mat-card-header>

    <mat-card-content>
      <app-detail-warnung [header]="'Meteorologische Warnungen'"
                          *ngIf="unwetterVorhersage?.meteorologischeWarnungen?.warnungen?.length > 0
                          || unwetterVorhersage?.meteorologischeWarnungen?.vorabinformationen.length > 0"
                          [unwetterWarnungen]="unwetterVorhersage?.meteorologischeWarnungen"></app-detail-warnung>

      <app-detail-warnung [header]="'Medizinische Warnungen'"
                          *ngIf="unwetterVorhersage?.medizinischeWarnungen?.warnungen?.length > 0
                          || unwetterVorhersage?.medizinischeWarnungen?.vorabinformationen.length > 0"
                          [unwetterWarnungen]="unwetterVorhersage?.medizinischeWarnungen"></app-detail-warnung>
    </mat-card-content>
  </mat-card>

</div>
